import { Row, Col, Typography, Divider } from "antd";
import React from "react";
import { useBreakpoints } from "./ResponsiveBreakPoints";
import "./propertyOptions.css";

const { Text } = Typography;

const PropertyOptionsAhmedabad = () => {
  const { isSuperLarge } = useBreakpoints();
  const propertyOptions = [
    {
      title: "Popular BHK Searches",
      items: [
        "5 BHK Duplex",
        "4 BHK Duplex",
        "5 BHK with Penthouse",
        "4 BHK with Penthouse",
        "3 BHK with Penthouse",
        "6 BHK Flats in Ahmedabad",
        "5 BHK Flats in Ahmedabad",
        "4 BHK Flats in Ahmedabad",
        "3 BHK Flats in Ahmedabad",
        "2.5 BHK Flats in Ahmedabad",
        "2 BHK Flats in Ahmedabad",
      ],
    },
    {
      title: "Popular Flat Searches",
      items: [
        "Flats in Bodakdev",
        "Flats in Thaltej",
        "Flats in Bopal",
        "Flats in Linkin Road",
        "Flats in Sindhubhavan Road",
        "Flats in Gota",
        "Flats in Shela",
        "Flats in Shilaj",
        "Flats in Vaishnodevi",
        "Flats in Science City",
        "Flats in Iscon Ambli",
      ],
    },
    {
      title: "Budget wise Searches",
      items: [
        "4 BHK Flats under 3 Cr",
        "3 BHK Flats under 1.5 Cr",
        "3 BHK Flats under 1 Cr",
        "2 BHK Flats under 70 lakhs",
        "3 BHK Flats under 80 lakhs",
        "Flats under 1 Cr in Ahmedabad",
        "Flats under 75 lakhs in Ahmedabad",
        "Flats under 50 lakhs in Ahmedabad",
      ],
    },
    {
      title: "Popular 3 BHK Searches",
      items: [
        "3 BHK in Adani Shantigram",
        "3 BHK Flats in Vaishnodevi",
        "3 BHK Apartments in Vaishnodevi",
        "3 BHK Apartments in Shilaj",
        "3 BHK Flats in Linkin Road",
        "3 BHK Apartments in Linkin Road",
        "3 BHK Apartments in Shela",
        "3 BHK Flats in Shela",
        "3 BHK Flats in Gota",
        "3 BHK Flats in Shilaj",
        "3 BHK Apartments in Gota",
      ],
    },
    {
      title: "Popular 4 BHK Searches",
      items: [
        "4 BHK Flats in Iscon Ambli",
        "4 BHK Flats in Science City",
        "4 BHK Apartments in Bopal",
        "4 BHK Flats in Bodakdev Ahmedabad",
        "4 BHK Flats in Thaltej",
        "4 BHK Flats in Sindhubhavan Road",
        "4 BHK Flats in Bopal",
        "4 BHK Flats in Ambli",
        "4 BHK Apartments in Thaltej",
        "4 BHK Apartments in Sindhubhavan Road",
        "4 BHK Apartments in Science City",
        "4 BHK Apartments in Ambli",
      ],
    },
  ];

  return (
    <Row justify="center" style={{ paddingBottom: 80 }}>
      <Col
        xs={22}
        sm={22}
        md={22}
        lg={18}
        xl={20}
        xxl={16}
        style={{ maxWidth: isSuperLarge ? "50%" : "" }}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Typography className="propertySearch">
              Property Options in Ahmedabad
            </Typography>
          </Col>

          <Col span={24}>
            <Row
              gutter={[24, 24]}
              justify={isSuperLarge ? "space-between" : "start"}
              wrap
            >
              {propertyOptions.map((section, idx) => (
                <Col
                  key={idx}
                  xs={24}
                  sm={12}
                  md={8}
                  style={{ flex: "1 1 220px" }}
                >
                  <h4 className="propertyHeading">{section.title}</h4>
                  <Divider className="propertyOptionDivider" />
                  <Row gutter={[0, 8]}>
                    {section.items.map((item, i) => (
                      <Col key={i} span={24}>
                        <Text className="propertyText2">{item}</Text>
                      </Col>
                    ))}
                  </Row>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PropertyOptionsAhmedabad;
